import React, { useEffect, useRef } from 'react'
import { Html5Qrcode } from 'html5-qrcode'
import { Button, Paper, Text, Center, Stack } from '@mantine/core'

const CameraScanner = ({ onScanSuccess, onClose }) => {
	const html5QrCodeRef = useRef(null)
	const runningRef = useRef(false)
	const scannedTextRef = useRef(null)

	useEffect(() => {
		const qrRegionId = 'qr-reader'
		const qrboxSize = Math.floor(Math.min(window.innerWidth, 400) * 0.7)

		const html5QrCode = new Html5Qrcode(qrRegionId)
		html5QrCodeRef.current = html5QrCode

		Html5Qrcode.getCameras()
			.then((devices) => {
				if (!devices.length) throw new Error('No cameras found')

				const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

				// Try to pick the appropriate camera
				let cameraId

				if (isMobile) {
					// Prefer back camera
					const backCam = devices.find((d) =>
						/back|rear|environment/i.test(d.label)
					)
					cameraId = backCam ? backCam.id : devices[0].id
				} else {
					// Prefer front camera
					const frontCam = devices.find((d) => /front|user|face/i.test(d.label))
					cameraId = frontCam ? frontCam.id : devices[0].id
				}

				return html5QrCode.start(
					cameraId,
					{
						fps: 10,
						qrbox: { width: qrboxSize, height: qrboxSize },
						aspectRatio: 1,
					},
					(decodedText) => {
						if (runningRef.current && !scannedTextRef.current) {
							runningRef.current = false
							scannedTextRef.current = decodedText

							html5QrCode
								.stop()
								.then(() => {
									html5QrCode.clear()
									onScanSuccess(decodedText)
								})
								.catch((err) => {
									console.warn('Failed to stop on scan:', err)
									onScanSuccess(decodedText)
								})
						}
					},
					() => {}
				)
			})
			.then(() => {
				runningRef.current = true
			})
			.catch((err) => {
				console.error('Camera error:', err)
				onClose()
			})

		return () => {
			const scanner = html5QrCodeRef.current
			if (scanner && runningRef.current) {
				scanner
					.stop()
					.then(() => scanner.clear())
					.catch(() => {})
			}
		}
	}, [onScanSuccess, onClose])

	return (
		<Paper withBorder p='md' radius='md' mt='md'>
			<Stack align='center' spacing='sm'>
				<Text size='sm' color='dimmed'>
					Scanning QR Code...
				</Text>
				<div
					id='qr-reader'
					style={{
						width: '100%',
						maxWidth: '400px',
						minHeight: '300px',
					}}
				/>
				<Button variant='default' onClick={onClose}>
					Cancel
				</Button>
			</Stack>
		</Paper>
	)
}

export default CameraScanner
